import { createContext, useContext, useEffect, useState } from "react";
import { useSession } from "../state/session.js";

/** A presentation-only preference, for previews without changing the player's saved setting. */
export const ReducedMotionContext = createContext(false);

/** Either preference stops the 3D animation, including changes while a viewer is open. */
export function useReducedMotion(): boolean {
  const app = useSession((state) => state.settings?.reducedMotion ?? false);
  const scoped = useContext(ReducedMotionContext);
  const [system, setSystem] = useState(() => window.matchMedia("(prefers-reduced-motion: reduce)").matches);
  useEffect(() => {
    const query = window.matchMedia("(prefers-reduced-motion: reduce)");
    const update = () => setSystem(query.matches);
    query.addEventListener("change", update);
    return () => query.removeEventListener("change", update);
  }, []);
  return app || system || scoped;
}
